import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-eb2898ea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "body-container"
};
const _hoisted_4 = {
  class: "notice-box"
};
const _hoisted_5 = {
  class: "new_header"
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "classify-box"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "more"
};
const _hoisted_10 = ["href"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_12 = {
  class: "news-list"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "main-notice-content"
};
const _hoisted_15 = ["title"];
const _hoisted_16 = {
  class: "title"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "curse-img"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = ["title"];
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
  class: "d"
};
const _hoisted_23 = {
  class: "df"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "day"
};
const _hoisted_26 = {
  class: "year"
};
const _hoisted_27 = ["onClick", "title"];

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link"
}, null, -1));

const _hoisted_29 = {
  key: 2,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowRight = _resolveComponent("ArrowRight");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.menu.module_name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_8);
  }), 128))], 2), _createElementVNode("div", _hoisted_9, [_createElementVNode("a", {
    href: `/notice.html?menuId=${$props.menu.menu_id}`
  }, [_hoisted_11, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })], 8, _hoisted_10)])]), _createElementVNode("div", _hoisted_12, [$data.mainRecommendNews ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "main-notice",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleLookDetail($data.mainRecommendNews))
  }, [_createElementVNode("img", {
    src: $data.mainRecommendNews ? $data.mainRecommendNews.news_cover_url : ''
  }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: "main-notice-top",
    title: $data.mainRecommendNews.news_name
  }, [_createElementVNode("div", _hoisted_16, _toDisplayString($data.mainRecommendNews.news_name), 1)], 8, _hoisted_15)])])) : _createCommentVNode("", true), $data.newsList.length ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["notice-list", {
      'notice-list-four': $data.mainRecommendNews
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList.slice(0, 2), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(index != 0 && index != 1 ? 'new_small' : 'notice-item'),
      onClick: $event => $options.handleLookDetail(item),
      key: index
    }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
      src: item.news_url || require('@/assets/images/common/course_cover.png'),
      alt: "",
      style: {
        "width": "100%",
        "height": "100%",
        "object-fit": "cover",
        "border-radius": "8px"
      }
    }, null, 8, _hoisted_19)]), _createElementVNode("div", {
      class: "title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_20), _createElementVNode("div", {
      class: "new-intro",
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_21)], 10, _hoisted_17);
  }), 128)), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList.slice(0), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
      class: "df-left",
      onClick: $event => $options.handleLookDetail(item)
    }, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'DD')), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'YYYY.MM')), 1)], 8, _hoisted_24), _createElementVNode("div", {
      class: "df-right",
      onClick: $event => $options.handleLookDetail(item),
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_27)]), _hoisted_28]);
  }), 128))])], 2)) : _createCommentVNode("", true), !$data.mainRecommendNews && $data.newsList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_Empty, {
    type: "message"
  })])) : _createCommentVNode("", true)])])])])])]);
}